/*
 * @Author: yidan.chen
 * @Date: 2025-02-06 11:52:57
 * @Last Modified by: yidan.chen
 * @Last Modified time: 2025-02-10 15:09:58
 */
import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link as RouterLink } from 'react-router-dom'

export interface IProps {
  children: React.ReactNode
  withLogo?: boolean
  withBacktToLogin?: boolean
}

const LoginFrame: React.FC<IProps> = ({
  children,
  withLogo,
  withBacktToLogin
}) => {
  return (
    <>
      <Box
        component='img'
        src='./images/login_bg.png'
        alt='Background'
        sx={{
          display: { xs: 'none', sm: 'none', md: 'block' },
          height: '100vh',
          objectFit: 'cover',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: -1
        }}
      />
      <Box
        sx={{
          display: { xs: 'none', sm: 'none', md: 'block' },
          position: 'fixed',
          width: '32%',
          height: '100%',
          top: '24%',
          left: '7%'
        }}>
        <Box
          component='img'
          src='./images/tagline1.png'
          alt='Logo'
          sx={{
            position: 'relative',
            width: 'auto',
            maxWidth: '100%',
            right: 0
          }}
        />
        <Box
          component='img'
          src='./images/tagline2.png'
          alt='Icon'
          sx={{
            position: 'relative',
            float: 'right',
            maxWidth: '80%'
          }}
        />
      </Box>

      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.45)',
          backdropFilter: 'blur(100px)',
          height: '100vh',
          borderRadius: '20px 0 0 20px',
          width: { xs: '100%', sm: '100%', md: '57%' },
          position: 'fixed',
          right: 0,
          top: 0
        }}>
        <Box
          sx={{
            position: 'fixed',
            top: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: withBacktToLogin ? 'space-between' : 'end',
            width: '100%',
            padding: '0 20px',
            zIndex: 10
          }}>
          {withBacktToLogin && (
            <Button
              variant='text'
              color='primary'
              size='large'
              component={RouterLink as React.ElementType}
              to='/login'
              startIcon={<ArrowBackIcon />}
              sx={{
                height: '40px',
                fontSize: '16px',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: 'transparent',
                  boxShadow: 'none'
                }
              }}>
              Back to Log In
            </Button>
          )}
          {withLogo && (
            <Box
              component='img'
              src='./images/icons/logo.png'
              alt='Icon'
              sx={{ height: '24px' }}
            />
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            position: 'relative'
          }}>
          {children}
          <Typography
            sx={{
              color: '#242424',
              textAlign: 'center',
              fontSize: '14px',
              position: 'absolute',
              bottom: '20px'
            }}>
            © UniUni {new Date().getFullYear()}. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default LoginFrame
